import { useState, useEffect } from "react";
import "./EventFinder.css";
import Colors from "../../../data/Colors";
import Card from "../../Card/Card";
import Form from "../../Form/Form";
import Button from "../../Button/Button";
import Loading from "../../Loading/Loading";
import EventCard from "../../EventCard/EventCard";
function EventFinder() {
  const [isLoading, setIsLoading] = useState(true);
  const [fetched, setFetched] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [allEvents, setAllEvents] = useState([]);
  const [events, setEvents] = useState([]);
  const [showChallenges, setShowChallenges] = useState(
    localStorage.getItem("challenges") === "false" ? false : true
  );
  const [challengeDistance, setChallengeDistance] = useState(
    localStorage.getItem("league_challenge") || 25
  );
  const [showCups, setShowCups] = useState(
    localStorage.getItem("cups") === "false" ? false : true
  );
  const [cupDistance, setCupDistance] = useState(
    localStorage.getItem("league_cup") || 25
  );
  const [showPrereleases, setShowPrereleases] = useState(
    localStorage.getItem("prereleases") === "false" ? false : true
  );
  const [prereleaseDistance, setPrereleaseDistance] = useState(
    localStorage.getItem("prerelease") || 25
  );
  const [streetAdress, setStreetAdress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [coordinates, setCoordinates] = useState(
    localStorage.getItem("x-coordinates")
      ? {
          x: localStorage.getItem("x-coordinates"),
          y: localStorage.getItem("y-coordinates"),
        }
      : false
  );

  const resetAddress = () => {
    setIsLoading(true);
    localStorage.removeItem("x-coordinates");
    localStorage.removeItem("y-coordinates");
    localStorage.removeItem("lastFetched");
    setCoordinates("");
  };

  const setCoordinatesInLocalStorageAndState = (x, y) => {
    localStorage.setItem("x-coordinates", x);
    localStorage.setItem("y-coordinates", y);
    setCoordinates({
      x: localStorage.getItem("x-coordinates"),
      y: localStorage.getItem("y-coordinates"),
    });
  };

  const handleUseCurrentLocationClick = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setCoordinatesInLocalStorageAndState(
          position.coords.longitude,
          position.coords.latitude
        );
      },
      () => {
        alert(
          "Do you have location services blocked? Are you on http instead of https? If not, you found a bug! If you have time, reach out to @seagrovetcg on X (Twitter) and hopefully you can help me improve this app.  In the meantime, try entering an address near your location."
        );
      },
      { timeout: 10000 }
    );
  };

  const onSubmit = (e) => {
    setErrorMessage("");
    e.preventDefault();
    fetch(
      `/addresses?street=${streetAdress
        .trim()
        .toLowerCase()
        .split(" ")
        .join("+")}&city=${city.trim().toLowerCase()}&state=${state
        .trim()
        .toLowerCase()}&zip=${zip
        .trim()
        .toLowerCase()}&benchmark=2020&format=json`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.length) {
          setCoordinatesInLocalStorageAndState(
            data[0].coordinates.x,
            data[0].coordinates.y
          );
        }
        if (!data.length) {
          return setErrorMessage("Not found. Please try a different address.");
        }
        if (data.length > 1) {
          return alert(
            "You found a bug I have been looking for!  Please message @seagrovetcg on twitter and let me know how you did it so I can fix it."
          );
        }
      });
  };

  const handleShowChange = (e) => {
    localStorage.setItem(e.target.value, e.target.checked);
    switch (e.target.value) {
      case "challenges":
        setShowChallenges(e.target.checked);
        break;
      case "cups":
        setShowCups(e.target.checked);
        break;
      case "prereleases":
        setShowPrereleases(e.target.checked);
        break;
      default:
        break;
    }
    getDesiredEvents();
  };
  const handleDistanceChange = (e) => {
    localStorage.setItem(e.target.name, e.target.value);
    switch (e.target.name) {
      case "league_challenge":
        setChallengeDistance(e.target.value);
        break;
      case "league_cup":
        setCupDistance(e.target.value);
        break;
      case "prerelease":
        setPrereleaseDistance(e.target.value);
        break;
      default:
        break;
    }
    getDesiredEvents();
  };
  useEffect(() => {
    getDesiredEvents();
  }, [
    showChallenges,
    showCups,
    showPrereleases,
    cupDistance,
    challengeDistance,
    prereleaseDistance,
    allEvents,
  ]);

  useEffect(() => {
    if (!coordinates) return;
    setIsLoading(true);
    if (Date.now() - localStorage.getItem("lastFetched") < 21600000) {
      setAllEvents(JSON.parse(localStorage.getItem("events")));
      return getDesiredEvents();
    }
    fetch(`/events?x=${coordinates.x}&y=${coordinates.y}`)
      .then((response) => response.json())
      .then((data) => {
        data.forEach((event) => {
          if (event.name === "Gemini Games League Challenge") {
            console.log(event.name);
            console.log(typeof event.when);
            console.log(event.when);
          }
        });
        data.sort((p1, p2) =>
          p1.date < p2.date ? -1 : p1.date > p2.date ? 1 : 0
        );
        setAllEvents(data);
        setFetched(true);
        return getDesiredEvents();
      });
  }, [coordinates]);

  const getDesiredEvents = () => {
    let eventsToShow = [...allEvents];
    if (!showChallenges) {
      eventsToShow = eventsToShow.filter(
        (event) => event.type !== "League Challenge"
      );
    } else {
      eventsToShow = eventsToShow.filter(
        (event) =>
          event.type === "Pre Release" ||
          event.type === "League Cup" ||
          (event.type === "League Challenge" &&
            event.distance < Number(challengeDistance))
      );
    }
    if (!showCups) {
      eventsToShow = eventsToShow.filter(
        (event) => event.type !== "League Cup"
      );
    } else {
      eventsToShow = eventsToShow.filter(
        (event) =>
          event.type === "League Challenge" ||
          event.type === "Pre Release" ||
          (event.type === "League Cup" && event.distance < Number(cupDistance))
      );
    }
    if (!showPrereleases) {
      eventsToShow = eventsToShow.filter(
        (event) => event.type !== "Pre Release"
      );
    } else {
      eventsToShow = eventsToShow.filter(
        (event) =>
          event.type === "League Challenge" ||
          event.type === "League Cup" ||
          (event.type === "Pre Release" &&
            event.distance < Number(prereleaseDistance))
      );
    }
    if (fetched) {
      localStorage.setItem("events", JSON.stringify(allEvents));
      localStorage.setItem("lastFetched", Date.now());
    }
    setEvents(eventsToShow, setIsLoading(false));
  };

  return (
    <>
      {coordinates ? (
        <main id="event-finder">
          <h2 className="page-title">PTCG Event Finder</h2>
          <div
            className="filterSection"
            style={{ color: "white", textAlign: "left" }}
          >
            <div>
              <div>
                <input
                  type="checkbox"
                  role="switch"
                  id="challenges"
                  name="challenges"
                  value="challenges"
                  onChange={handleShowChange}
                  defaultChecked={
                    localStorage.getItem("challenges") === "false"
                      ? false
                      : true
                  }
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                />
                <label htmlFor="challenges">
                  <span className="checkbox"></span>
                  Show Challenges within{" "}
                  <select
                    name="league_challenge"
                    id="league_challenge"
                    onChange={handleDistanceChange}
                    value={localStorage.getItem("league_challenge") || 25}
                  >
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                    <option value="150">150</option>
                    <option value="200">200</option>
                    <option value="250">250</option>
                  </select>{" "}
                  miles
                </label>
              </div>
              <div>
                <input
                  type="checkbox"
                  role="switch"
                  id="cups"
                  name="cups"
                  value="cups"
                  onChange={handleShowChange}
                  defaultChecked={
                    localStorage.getItem("cups") === "false" ? false : true
                  }
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                />
                <label htmlFor="cups">
                  <span className="checkbox"></span>
                  Show Cups within{" "}
                  <select
                    name="league_cup"
                    id="league_cup"
                    onChange={handleDistanceChange}
                    value={localStorage.getItem("league_cup") || 25}
                  >
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                    <option value="150">150</option>
                    <option value="200">200</option>
                    <option value="250">250</option>
                  </select>{" "}
                  miles
                </label>
              </div>
              <div>
                <input
                  type="checkbox"
                  role="switch"
                  id="prereleases"
                  name="prereleases"
                  value="prereleases"
                  onChange={handleShowChange}
                  defaultChecked={
                    localStorage.getItem("prereleases") === "false"
                      ? false
                      : true
                  }
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                />
                <label htmlFor="prereleases">
                  <span className="checkbox"></span> Show Prereleases within{" "}
                  <select
                    name="prerelease"
                    id="prerelease"
                    onChange={handleDistanceChange}
                    value={localStorage.getItem("prerelease") || 25}
                  >
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                    <option value="150">150</option>
                    <option value="200">200</option>
                    <option value="250">250</option>
                  </select>{" "}
                  miles
                </label>
              </div>
              <div style={{ textAlign: "center", margin: "35px auto 35px" }}>
                <Button text="Change Address" handleClick={resetAddress} />
              </div>
            </div>
          </div>
          <div className="eventSection">
            <h3 className="sub-title">Tournaments</h3>
            <p>
              Tournament listings based on original TO input and will not show
              any updates. Please check with your TO or pokemon.com before
              traveling.
            </p>
            <div className="eventHolder">
              {isLoading ? (
                <Loading text="Checking for new events." />
              ) : !events.length ? (
                <p style={{ color: "white" }}>
                  No events to show. Please refine your search.
                </p>
              ) : (
                events.map((event) => {
                  return <EventCard event={event} key={event.guid} />;
                })
              )}
            </div>
          </div>
        </main>
      ) : (
        <Card
          children={
            <>
              <Button
                text="Use Current Location"
                handleClick={() => handleUseCurrentLocationClick()}
                classes={"use-current-location-button"}
              />
              <hr
                style={{
                  margin: "40px auto 0",
                  width: "300px",
                  maxWidth: "80%",
                }}
              />
              <span
                className="or"
                style={{
                  backgroundColor: Colors.darker,
                  position: "relative",
                  top: "-10px",
                  padding: "10px",
                }}
              >
                {" "}
                OR{" "}
              </span>

              <Form
                fields={[
                  {
                    name: "address",
                    label: "Street Address",
                    value: streetAdress,
                    onChange: (e) => setStreetAdress(e.target.value),
                  },
                  {
                    name: "city",
                    label: "City",
                    value: city,
                    onChange: (e) => setCity(e.target.value),
                  },
                  {
                    name: "state",
                    label: "State",
                    value: state,
                    onChange: (e) => setState(e.target.value),
                  },
                  {
                    name: "zip",
                    label: "Zip Code",
                    value: zip,
                    onChange: (e) => setZip(e.target.value),
                  },
                ]}
                onSubmit={onSubmit}
              />
              {errorMessage && <p>{errorMessage}</p>}
            </>
          }
          title="Find Events Near"
          width="100%"
          height="auto"
          backgroundColor={Colors.darker}
          color="white"
          className="find-events-card"
        />
      )}
    </>
  );
}

export default EventFinder;
